<div class="gallery">
    <app-stepper variant="continuous-bar">
        <app-step label="One">
            <h3>Hello, World!</h3>
        </app-step>
        <app-step label="Two">
            <h3>Second Step</h3>
        </app-step>
        <app-step label="Three">
            <h3>Third Step</h3>
        </app-step>
    </app-stepper>
    <hr />
    <app-date-picker [(ngModel)]="dateA"></app-date-picker>
    <app-date-picker [(ngModel)]="dateA" [disabled]="true"></app-date-picker>
    <br />
    <br />
    <app-date-picker [(ngModel)]="dateB"></app-date-picker>
    <app-date-picker
        [(ngModel)]="dateB"
        timezone="Europe/London"
    ></app-date-picker>
    <br />
    <br />
    <form [formGroup]="form">
        <app-date-picker formControlName="startDate"></app-date-picker>
        <app-date-picker formControlName="endDate"></app-date-picker>
        <br />
        <br />
        <h4>Tag List - inside a form (formControlName)</h4>
        <app-tag-list formControlName="tags" />
    </form>

    <h4>Tag List</h4>
    <app-tag-list [(ngModel)]="tags" [disabled]="true" />

    <h4>Tag - display only</h4>
    <app-tag [option]="tag" />

    <h4>Tag - removable</h4>
    <app-tag [option]="tag" (removed)="onTagRemoved($event)" />

    <h4>Tag - clickable</h4>
    <app-tag [option]="tag" (clicked)="onTagClick($event)" />
    <hr />
    <button mat-raised-button (click)="showSuccess()">
        Show Success Snackbar
    </button>
    <button mat-raised-button (click)="showError()">Show Error Snackbar</button>

    <hr />

    <h4>Confirm Modal</h4>
    <button mat-raised-button (click)="openConfirmModal()">
        Open Confirm Modal
    </button>
    <button mat-raised-button (click)="openDangerConfirmModal()">
        Open Confirm Modal (danger)
    </button>

    <hr />

    <h4>Progress Bar</h4>
    <mat-progress-bar mode="determinate" [value]="75" />
    <br />
    <mat-progress-bar mode="determinate" [value]="30" class="intensity" />
    <br />
    <h4>Date Range Bar</h4>
    <span>Scheduled</span>
    <app-date-range-bar [startDate]="endDate" [endDate]="laterEndDate" />
    <br />
    <span>Scheduled and Ongoing</span>
    <app-date-range-bar [startDate]="endDate" />
    <br />
    <span>Live, just started today (now)</span>
    <app-date-range-bar [startDate]="startDate" [endDate]="endDate" />
    <br />
    <span>Live</span>
    <app-date-range-bar [startDate]="pastStartDate" [endDate]="endDate" />
    <br />
    <span>Live and Ongoing</span>
    <app-date-range-bar [startDate]="startDate" />
    <br />
    <span>Paused</span>
    <app-date-range-bar [startDate]="startDate" [colorDisabled]="true" />
    <br />
    <span>Expired</span>
    <app-date-range-bar [startDate]="pastStartDate" [endDate]="startDate" />

    <hr />

    <h4>Radio</h4>
    <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Option 1</mat-radio-button>
        <mat-radio-button value="2">Option 2</mat-radio-button>
        <mat-radio-button disabled value="3">Option 3</mat-radio-button>
    </mat-radio-group>

    <hr />

    <h4>Image Upload</h4>
    <app-image-upload
        label="image"
        (uploaded)="onImageUploaded($event)"
    ></app-image-upload>
    <br />
    <h4>Image Upload - pre-filled (edit / replace)</h4>
    <app-image-upload
        label="image"
        initialUrl="/assets/SiriusXM-Logo-onLight.svg"
        (uploaded)="onImageUploaded($event)"
    ></app-image-upload>

    <hr />

    <h4>Loading</h4>
    <div class="loading"></div>
    <h4>Loading - overridden size</h4>
    <div class="loading" style="--loading-width: 12rem"></div>

    <hr />

    <h4>Form Action Bar (sticky footer)</h4>
    <div class="action-bar">
        <tools-button
            [variant]="ButtonVariant.OUTLINE"
            (onClick)="onFooterCancel()"
        >
            Cancel
        </tools-button>
        <tools-button (onClick)="onFooterSave()">Save</tools-button>
    </div>
</div>
